import React, { useState, useEffect } from 'react'
import './FullSchedule.css'
import './FullScheduleCards.css'
import { useParams, Link } from 'react-router-dom'
import Footer from '../components/UIElements/Footer'

const FullSchedule = () => {
	console.log('inside FullSchedule')

	const [isLoading, setIsLoading] = useState(false)
	const [error, setError] = useState()
	const [allGamesAndEvents, setAllGamesAndEvents] = useState([])
	const [showPreviousGames, setShowPreviousGames] = useState({})

	useEffect(() => {
		//console.log('INSIDE USE EFFECT')
		const sendRequest = async () => {
			setIsLoading(true)
			try {
				const response = await fetch(
					process.env.REACT_APP_BACKEND_URL + '/admin/allGamesAndEvents',
				)

				const responseData = await response.json()

				if (!response.ok) {
					throw new Error(responseData.message)
				}

				setAllGamesAndEvents(responseData.allItemsThisWeek)

				setIsLoading(false)
			} catch (err) {
				setError(err.message)
			}
			setIsLoading(false)
		}
		sendRequest()
	}, [])
	//
	//
	const formatGameDate = (game) => {
		const months = {
			'01': 'Jan.',
			'02': 'Feb.',
			'03': 'Mar.',
			'04': 'Apr.',
			'05': 'May',
			'06': 'June',
			'07': 'July',
			'08': 'Aug.',
			'09': 'Sept.',
			10: 'Oct.',
			11: 'Nov.',
			12: 'Dec.',
		}

		return `${game.dayOfWeek}, ${months[game.date.substr(0, 2)]} ${game.date.substr(
			3,
			2,
		)}`
	}

	const formatGameTime = (game) => {
		const hour = game.time.substr(0, 2)
		const minute = game.time.substr(3, 2)

		const times = {
			'00': `12:${minute} am`,
			'01': `1:${minute} am`,
			'02': `2:${minute} am`,
			'03': `3:${minute} am`,
			'04': `4:${minute} am`,
			'05': `5:${minute} am`,
			'06': `6:${minute} am`,
			'07': `7:${minute} am`,
			'08': `8:${minute} am`,
			'09': `9:${minute} am`,
			10: `10:${minute} am`,
			11: `11:${minute} am`,
			12: `12:${minute} pm`,
			13: `1:${minute} pm`,
			14: `2:${minute} pm`,
			15: `3:${minute} pm`,
			16: `4:${minute} pm`,
			17: `5:${minute} pm`,
			18: `6:${minute} pm`,
			19: `7:${minute} pm`,
			20: `8:${minute} pm`,
			21: `9:${minute} pm`,
			22: `10:${minute} pm`,
			23: `11:${minute} pm`,
			24: `12:${minute} am`,
		}

		return times[hour]
	}

	const getDisplayScore = (game) => {
		if (!game.score) {
			return 'TBP'
		}

		const scoreParts = game.score.split('-').map((score) => score.trim())

		if (scoreParts.length !== 2) {
			return game.score
		}

		const firstScore = Number(scoreParts[0])
		const secondScore = Number(scoreParts[1])

		if (Number.isNaN(firstScore) || Number.isNaN(secondScore)) {
			return game.score
		}

		/*
		Mobile cards display:

		HOME SCORE - VISITOR SCORE
	*/

		if (game.winner === game.homeTeamId) {
			const homeScore = Math.max(firstScore, secondScore)
			const visitorScore = Math.min(firstScore, secondScore)

			return `${homeScore} - ${visitorScore}`
		}

		if (game.winner === game.visitorTeamId) {
			const homeScore = Math.min(firstScore, secondScore)
			const visitorScore = Math.max(firstScore, secondScore)

			return `${homeScore} - ${visitorScore}`
		}

		return `${firstScore} - ${secondScore}`
	}

	const getGameStatus = (game) => {
		if (!game.score) {
			return ''
		}

		if (game.status === 'Shootout') {
			return 'SO'
		}

		if (game.status === 'Overtime') {
			return 'OT'
		}

		return 'FINAL'
	}
	//
	//
	//
	const errorHandler = () => {
		setError(null)
	}
	//
	//
	const getGameDateObject = (game) => {
		if (!game.date) {
			return null
		}

		const splitDate = game.date.split('-')

		const month = parseInt(splitDate[0], 10) - 1
		const day = parseInt(splitDate[1], 10)
		const year = parseInt(splitDate[2], 10)

		return new Date(year, month, day)
	}

	const isGameOlderThanTwoDays = (game) => {
		const gameDate = getGameDateObject(game)

		if (!gameDate) {
			return false
		}

		// Never hide games that still haven't been scored
		if (game.status === 'TBD') {
			return false
		}

		const today = new Date()
		today.setHours(0, 0, 0, 0)

		const twoDaysAgo = new Date(today)
		twoDaysAgo.setDate(today.getDate() - 2)

		return gameDate < twoDaysAgo
	}

	const togglePreviousGames = (venue) => {
		setShowPreviousGames((prev) => ({
			...prev,
			[venue]: !prev[venue],
		}))
	}
	//
	//
	//
	//
	let distinctVenues
	let distinctVenuesArray
	distinctVenuesArray = []

	if (allGamesAndEvents.length !== 0) {
		distinctVenues = [...new Set(allGamesAndEvents.map((x) => x.venueName))]
		for (let i = 0; i < distinctVenues.length; i++) {
			distinctVenuesArray.push(distinctVenues[i])
		}
	}

	let dateBlock
	dateBlock = []
	if (!isLoading && allGamesAndEvents.length === 0) {
		return (
			<div style={{ overflowX: 'hidden' }}>
				<React.Fragment>
					{/* <AdminNavigation /> */}
					<div className='Leagues'>
						<h1>NOTHING SCHEDULED YET!</h1>
					</div>
				</React.Fragment>
			</div>
		)
	}
	if (!isLoading && allGamesAndEvents.length !== 0 && distinctVenuesArray) {
		distinctVenuesArray.forEach((venue) => {
			dateBlock.push(
				<div className='Schedule'>
					{/* <AdminNavigation /> */}
					<h1>{venue}</h1>
					<table id='defaultScheduleDisplay'>
						<thead>
							<tr>
								<th>Date/Time</th>
								{/* <th>Time</th> */}
								<th>League</th>
								{/* <th>Status</th> */}
								<th>Visitor/Home</th>
								<th></th>
								<th></th>
								<th>Winner</th>
								<th>Score</th>
								{/* <th>Venue</th> */}
							</tr>
						</thead>
						<tbody>
							{allGamesAndEvents.map((game, key) => {
								if (game.venueName === venue) {
									return (
										<tr key={key}>
											<td>
												{game.dayOfWeek}
												{', '}
												{game.date.substr(0, 2) === '01' &&
													'Jan. ' + game.date.substr(3, 2)}
												{game.date.substr(0, 2) === '02' &&
													'Feb. ' + game.date.substr(3, 2)}
												{game.date.substr(0, 2) === '03' &&
													'Mar. ' + game.date.substr(3, 2)}
												{game.date.substr(0, 2) === '04' &&
													'Apr. ' + game.date.substr(3, 2)}
												{game.date.substr(0, 2) === '05' &&
													'May ' + game.date.substr(3, 2)}
												{game.date.substr(0, 2) === '06' &&
													'June ' + game.date.substr(3, 2)}
												{game.date.substr(0, 2) === '07' &&
													'July ' + game.date.substr(3, 2)}
												{game.date.substr(0, 2) === '08' &&
													'Aug. ' + game.date.substr(3, 2)}
												{game.date.substr(0, 2) === '09' &&
													'Sept. ' + game.date.substr(3, 2)}
												{game.date.substr(0, 2) === '10' &&
													'Oct. ' + game.date.substr(3, 2)}
												{game.date.substr(0, 2) === '11' &&
													'Nov. ' + game.date.substr(3, 2)}
												{game.date.substr(0, 2) === '12' &&
													'Dec. ' + game.date.substr(3, 2)}
												<br></br>
												{game.time.substr(0, 2) === '00' &&
													'12:' + game.time.substr(3, 2) + ' am'}
												{game.time.substr(0, 2) === '01' &&
													'1:' + game.time.substr(3, 2) + ' am'}
												{game.time.substr(0, 2) === '02' &&
													'2:' + game.time.substr(3, 2) + ' am'}
												{game.time.substr(0, 2) === '03' &&
													'3:' + game.time.substr(3, 2) + ' am'}
												{game.time.substr(0, 2) === '04' &&
													'4:' + game.time.substr(3, 2) + ' am'}
												{game.time.substr(0, 2) === '05' &&
													'5:' + game.time.substr(3, 2) + ' am'}
												{game.time.substr(0, 2) === '06' &&
													'6:' + game.time.substr(3, 2) + ' am'}
												{game.time.substr(0, 2) === '07' &&
													'7:' + game.time.substr(3, 2) + ' am'}
												{game.time.substr(0, 2) === '08' &&
													'8:' + game.time.substr(3, 2) + ' am'}
												{game.time.substr(0, 2) === '09' &&
													'9:' + game.time.substr(3, 2) + ' am'}
												{game.time.substr(0, 2) === '10' &&
													'10:' + game.time.substr(3, 2) + ' am'}
												{game.time.substr(0, 2) === '11' &&
													'11:' + game.time.substr(3, 2) + ' am'}
												{game.time.substr(0, 2) === '12' &&
													'12:' + game.time.substr(3, 2) + ' pm'}
												{game.time.substr(0, 2) === '13' &&
													'1:' + game.time.substr(3, 2) + ' pm'}
												{game.time.substr(0, 2) === '14' &&
													'2:' + game.time.substr(3, 2) + ' pm'}
												{game.time.substr(0, 2) === '15' &&
													'3:' + game.time.substr(3, 2) + ' pm'}
												{game.time.substr(0, 2) === '16' &&
													'4:' + game.time.substr(3, 2) + ' pm'}
												{game.time.substr(0, 2) === '17' &&
													'5:' + game.time.substr(3, 2) + ' pm'}
												{game.time.substr(0, 2) === '18' &&
													'6:' + game.time.substr(3, 2) + ' pm'}
												{game.time.substr(0, 2) === '19' &&
													'7:' + game.time.substr(3, 2) + ' pm'}
												{game.time.substr(0, 2) === '20' &&
													'8:' + game.time.substr(3, 2) + ' pm'}
												{game.time.substr(0, 2) === '21' &&
													'9:' + game.time.substr(3, 2) + ' pm'}
												{game.time.substr(0, 2) === '22' &&
													'10:' + game.time.substr(3, 2) + ' pm'}
												{game.time.substr(0, 2) === '23' &&
													'11:' + game.time.substr(3, 2) + ' pm'}
												{game.time.substr(0, 2) === '24' &&
													'12:' + game.time.substr(3, 2) + ' am'}
											</td>
											<td>
												{(game.leagueName && game.leagueName) || game.eventName}
											</td>
											{/* <td>
												{(game.status && game.status !== 'TBP' && (
													<Link
														style={{
															textDecoration: 'none',
															fontWeight: 600,
															color: 'black',
														}}
														to={`/gameSummary/${game._id}`}
													>
														{game.status}
													</Link>
												)) ||
													'TBP'}
											</td> */}
											{game.visitorTeamName && (
												<td>
													{game.visitorTeamSeed > 0 &&
														'(' + game.visitorTeamSeed + ') '}
													{game.visitorTeamName && game.visitorTeamName}
													<br></br>
													{' @ '}
													<br></br>
													{game.homeTeamSeed > 0 &&
														'(' + game.homeTeamSeed + ') '}
													{game.homeTeamName && game.homeTeamName}
													{game.playoff && (
														<div style={{ color: 'red', fontWeight: 'bold' }}>
															PLAYOFF GAME
														</div>
													)}

													{game.championship && (
														<div style={{ color: 'red', fontWeight: 'bold' }}>
															CHAMPIONSHIP GAME
														</div>
													)}
												</td>
											)}
											{game.playoff && <td></td>}
											{game.championship && <td></td>}
											{game.eventName && (
												<td
													style={{
														fontWeight: 'bold',
														backgroundColor: 'pink',
													}}
												>
													{game.eventName}
												</td>
											)}
											{!game.playoff && !game.championship && <td></td>}

											<td>
												{game.summary && (
													<Link
														style={{
															textDecoration: 'none',
															fontWeight: 600,
															color: 'black',
														}}
														to={`/gameSummary/${game._id}`}
													>
														RECAP
													</Link>
												)}
											</td>

											{game.homeTeamId && game.winner === game.homeTeamId && (
												<td>{game.homeTeamName}</td>
											)}

											{game.visitorTeamId &&
												game.winner === game.visitorTeamId && (
													<td>{game.visitorTeamName}</td>
												)}
											{game.status &&
												game.status !== 'TBP' &&
												game.winner !== game.homeTeamId &&
												game.winner !== game.visitorTeamId && <td>TIE</td>}
											{!game.score && <td></td>}
											<td>
												{game.score && (
													<Link
														style={{
															textDecoration: 'none',
															fontWeight: 600,
															color: 'black',
														}}
														to={`/gameSummary/${game._id}`}
													>
														{game.score}
														{game.status === 'Overtime' && ' (OT)'}
														{game.status === 'Shootout' && ' (SO)'}
													</Link>
												)}
											</td>
										</tr>
									)
								}
							})}
						</tbody>
					</table>
					<div className='scheduleCardsMobile'>
						{allGamesAndEvents.some(
							(game) =>
								game.venueName === venue && isGameOlderThanTwoDays(game),
						) && (
							<div
								onClick={() => togglePreviousGames(venue)}
								style={{
									textAlign: 'center',
									marginTop: '0.25rem',
									marginBottom: '1rem',
									fontSize: '0.85rem',
									fontWeight: '600',
									textDecoration: 'underline',
									cursor: 'pointer',
								}}
							>
								{showPreviousGames[venue]
									? 'Hide previous games'
									: 'Click to see previous games'}
							</div>
						)}

						{allGamesAndEvents
							.filter((game) => {
								if (game.venueName !== venue) {
									return false
								}

								if (showPreviousGames[venue]) {
									return true
								}

								return !isGameOlderThanTwoDays(game)
							})
							.map((game, key) => {
								const isSpecialGame =
									game.playoff || game.championship || game.description

								return (
									<div
										className={`scheduleCard ${
											isSpecialGame ? 'scheduleCardSpecial' : ''
										}`}
										key={`full-schedule-mobile-${game._id || key}`}
									>
										<div className='scheduleCard__header'>
											<div>{formatGameDate(game)}</div>

											<div className='scheduleCard__league'>
												{game.championship
													? 'CHAMPIONSHIP'
													: game.playoff
														? 'PLAYOFF'
														: game.leagueName || game.eventName || 'Game'}
											</div>

											<div>{formatGameTime(game)}</div>
										</div>

										{game.homeTeamName && game.visitorTeamName ? (
											<>
												<div className='scheduleCard__body'>
													<div className='scheduleCard__team'>
														<span
															className={
																game.winner === game.homeTeamId
																	? 'scheduleCard__winnerPill'
																	: ''
															}
														>
															{game.homeTeamSeed > 0 &&
																`(${game.homeTeamSeed}) `}
															{game.homeTeamName}
														</span>
													</div>

													<div className='scheduleCard__scoreBox'>
														{game.score ? (
															<Link
																to={`/gameSummary/${game._id}`}
																className='scheduleCard__score'
															>
																{getDisplayScore(game)}
															</Link>
														) : (
															<div className='scheduleCard__score'>TBP</div>
														)}

														{game.score && (
															<div className='scheduleCard__status'>
																{getGameStatus(game)}
															</div>
														)}
													</div>

													<div className='scheduleCard__team'>
														<span
															className={
																game.winner === game.visitorTeamId
																	? 'scheduleCard__winnerPill'
																	: ''
															}
														>
															{game.visitorTeamSeed > 0 &&
																`(${game.visitorTeamSeed}) `}
															{game.visitorTeamName}
														</span>
													</div>
												</div>

												<div className='scheduleCard__venue'>
													📍 {game.venueName}
												</div>

												{game.description && (
													<div className='scheduleCard__description'>
														{game.description}
													</div>
												)}

												{game.championship && (
													<div className='scheduleCard__description'>
														CHAMPIONSHIP GAME
													</div>
												)}

												{game.playoff && !game.championship && (
													<div className='scheduleCard__description'>
														PLAYOFF GAME
													</div>
												)}
											</>
										) : (
											<>
												<div className='scheduleCard__event'>
													{game.eventName ||
														game.description ||
														'Scheduled Event'}
												</div>

												<div className='scheduleCard__venue'>
													📍 {game.venueName}
												</div>
											</>
										)}
									</div>
								)
							})}
					</div>
				</div>,
			)
		})
	}

	return (
		<div style={{ overflowX: 'hidden' }}>
			<React.Fragment>
				{dateBlock && dateBlock}
				<Footer />
			</React.Fragment>
		</div>
	)
}

export default FullSchedule
